import React, { useEffect, useRef, useState } from "react";
import { GetASD, GroupByForeignKey, GroupByPropCheck, GroupByProps } from "../../Actions/GetContainer";
import { EjercicioByRange } from "../../Helper/EjercicioByRange";
import { Mes } from "../../Helper/Mes";
import { capitalizePalabras } from "../../../../Helpers/CapitalizePalabras";
import { Comparacion } from "./Comparacion";

export const BoxStructure = ({
    children,
    updateBoxState,
    onBoxChange,
    boxState,
    BoxClick,
    dejercicio = 'flex',
    dmesinicio = "flex",
    dmesfin = "flex",
    dcomparacion = "flex",
    titulo = '',
    titulo_filtro,
    subtitulo = '',
    mostraradr = true,
    mostrarsucursal = true,
    mostrardepartamento = true,
    cargarADR = true,
    cargarDepartamento = false,
    cargarSucursal = true,
    cargarfiltros = true,
    extrayear = 0,
    usuariodefault = null,
    sucursales
}) => {
    const loadingRef = useRef();
    const loadingCargandoRef = useRef();
    const loadingErrorRef = useRef();
    const año = new Date().getFullYear();
    const mesActual = new Date().getMonth() + 1;
    const [stateError, setError] = useState("");
    const [state, setstate] = useState({
        data: [],
        adr: [],
        sucursal: [],
        departamento: [],
        ejercicioinicio: año,
        ejerciciofin: año,
        periodoinicio: mesActual,
        periodofin: mesActual,
        comparacion: 'R',
        tsucursal: '',
        tdeptos: ''
    });
    const { data, adr, sucursal, departamento, ejercicioinicio, ejerciciofin, periodoinicio, periodofin, comparacion } =
        state;

    const GetChildren = (key) => {
        if (children === undefined || children === null)
            return <></>
        if (Array.isArray(children)) {

            var result = children.filter(x => x.key === key);
            if (result !== undefined && result !== null && result.length > 0) {
                return result[0]
            }
        }
        if (children.key === key)
            return children;

        return <></>
    }
    useEffect(() => {
        onClose();
        if (cargarADR || cargarSucursal || cargarDepartamento)
            GetASD(usuariodefault)
                .then((res) => {
                    setstate({
                        ...state,
                        data: res,
                    });
                    onBoxChange("pv", {
                        adr: GroupByProps(res, ["idadr", "adr"]),
                        sucursal: [],
                        departamento: [],
                    });
                })
                .catch((err) => console.log(err));
    }, []);

    const idsSucursalPermitidas = [...new Set(sucursales?.map(s => String(s.idsucursal)))];

    const sucursalFiltrada = sucursal.filter(item => idsSucursalPermitidas.includes(item.idsucursal));

    const adrFiltrado = adr?.filter(itemAdr =>
        data.some(d => String(d.idadr) === String(itemAdr.idadr) && idsSucursalPermitidas.includes(String(d.idsucursal)))
    );


    useEffect(() => {
        if (cargarADR || cargarSucursal || cargarDepartamento) {
            var newadr = GroupByPropCheck(data, ["idadr", "adr"]);
            var newsucursal = GroupByPropCheck(data, ["idsucursal", "sucursal"], false);
            var newdepartamento = GroupByPropCheck(
                data,
                ["iddepartamento", "departamento"],
                false
            );
            setstate({
                ...state,
                adr: newadr,
                sucursal: newsucursal,
                departamento: newdepartamento,
            });
            if (updateBoxState !== undefined && updateBoxState !== null) {
                updateBoxState({
                    ...boxState,
                    arrayadr: newadr,
                    arraysucursal: newsucursal,
                    arraydepartamento: newdepartamento
                })
            }
        }
    }, [data]);
    const onChange = ({ target }) => {
        setstate({
            ...state,
            [target.name]: target.value,
        });
        onBoxChange(target.name, target.value);
    };
    const labelclick = ({ target }) => {
        if (cargarADR || cargarSucursal || cargarDepartamento)
            target.parentNode.firstChild.click();
    }
    const selectedClick = ({ target }, index) => {
        if (!cargarADR && !cargarSucursal && !cargarDepartamento) return;
        switch (target.name) {
            case "chk-adr":
                var newarray = adr;
                newarray[index].checked = target.checked;

                var newarrarsucursal = [];
                var newarraydepartamento = [];
                var adrActive = [];
                newarray.forEach((item) => {
                    if (item.checked) {
                        adrActive = [...adrActive, { idadr: item.idadr, adr: item.adr }];
                        newarrarsucursal = newarrarsucursal.concat(
                            GroupByForeignKey(data, "idadr", item.idadr, [
                                "idsucursal",
                                "sucursal",
                            ])
                        );
                        newarraydepartamento = newarraydepartamento.concat(
                            GroupByForeignKey(data, "idadr", item.idadr, [
                                "iddepartamento",
                                "departamento",
                            ])
                        );
                    }
                });
                onBoxChange("pv", {
                    adr: adrActive,
                    sucursal: [],
                    departamento: [],
                });
                setstate({
                    ...state,
                    adr: newarray,
                    sucursal:
                        newarrarsucursal.length == 0
                            ? GroupByPropCheck(data, ["idsucursal", "sucursal"], false)
                            : GroupByPropCheck(
                                newarrarsucursal,
                                ["idsucursal", "sucursal"],
                                false
                            ),
                    departamento:
                        newarraydepartamento.length == 0
                            ? GroupByPropCheck(
                                data,
                                ["iddepartamento", "departamento"],
                                false
                            )
                            : GroupByPropCheck(
                                newarraydepartamento,
                                ["iddepartamento", "departamento"],
                                false
                            ),
                });
                break;
            case "chk-sucursal":
                var newarray = sucursalFiltrada;
                newarray[index].checked = target.checked;

                var newarraydepartamento = [];
                var sucursalactiva = [];
                newarray.forEach((item) => {
                    if (item.checked) {
                        sucursalactiva = [
                            ...sucursalactiva,
                            { idsucursal: item.idsucursal, sucursal: item.sucursal },
                        ];
                        newarraydepartamento = newarraydepartamento.concat(
                            GroupByForeignKey(data, "idsucursal", item.idsucursal, [
                                "iddepartamento",
                                "departamento",
                            ])
                        );
                    }
                });
                onBoxChange("pv", {
                    adr: boxState.pv.adr,
                    sucursal: sucursalactiva,
                    departamento: [],
                });
                setstate({
                    ...state,
                    sucursal: newarray,
                    departamento:
                        newarraydepartamento.length == 0
                            ? GroupByPropCheck(
                                data,
                                ["iddepartamento", "departamento"],
                                false
                            )
                            : GroupByPropCheck(
                                newarraydepartamento,
                                ["iddepartamento", "departamento"],
                                false
                            ),
                });
                break;
            default:
                var newarray = departamento;
                var departamentoactivo = [];
                newarray[index].checked = target.checked;

                newarray.forEach((item) => {
                    if (item.checked) {
                        departamentoactivo = [
                            ...departamentoactivo,
                            {
                                iddepartamento: item.iddepartamento,
                                departamento: item.departamento,
                            },
                        ];
                    }
                });
                onBoxChange("pv", {
                    adr: boxState.pv.adr,
                    sucursal: boxState.pv.sucursal,
                    departamento: departamentoactivo,
                });
                setstate({
                    ...state,
                    departamento: newarray,
                });
                break;
        }
    };
    const onClick = () => {
        const element = document.getElementById("box-structure-bussiness-filtros-2");
        if (element != undefined && element != null) {
            element.style.display = "flex";
        }
    };
    const onClose = () => {
        const element = document.getElementById("box-structure-bussiness-filtros-2");
        if (element != undefined && element != null) {
            element.style.display = "none";
        }
        closeConsulta();
    };
    const closeConsulta = () => {
        if (loadingRef.current != undefined && loadingRef.current != null)
            loadingRef.current.style.display = "none";
        if (
            loadingCargandoRef.current != undefined &&
            loadingCargandoRef.current != null
        )
            loadingCargandoRef.current.style.display = "flex;";
        if (loadingErrorRef.current != undefined && loadingErrorRef.current != null)
            loadingErrorRef.current.style.display = "none";
    };
    const consultar = () => {
        // if (loadingRef.current != undefined && loadingRef.current != null)
        //   loadingRef.current.style.display = "flex";
        // if (
        //   loadingCargandoRef.current != undefined &&
        //   loadingCargandoRef.current != null
        // )
        //   loadingCargandoRef.current.style.display = "flex";
        // if (loadingErrorRef.current != undefined && loadingErrorRef.current != null)
        //   loadingErrorRef.current.style.display = "none";
        BoxClick()
            .then((res) => {
                var tituloSucursal = '';
                var tituloDeptos = '';


                //Header sucursales
                if (boxState.pv.sucursal != undefined && boxState.pv.sucursal != null) {

                    if (boxState.pv.sucursal.length === 0 && state.adr.length === 1) {

                        if (state.adr[0].idadr === '1' && state.sucursal.length < 7) {
                            state.sucursal.forEach(item => {
                                tituloSucursal += `${item.idsucursal}-${item.sucursal}${','}`;
                            })
                        } else if (state.adr[0].idadr === '2' && state.sucursal.length < 5) {
                            state.sucursal.forEach(item => {
                                tituloSucursal += `${item.idsucursal}-${item.sucursal}${','}`;
                            })
                        } else {
                            console.log('else')
                            tituloSucursal = `Region ${state.adr[0].adr},`
                        }
                    } else {
                        if (boxState.pv.sucursal.length == 0 && state.sucursal.length) {
                            if (boxState.pv.adr.length == 1) {
                                tituloSucursal = `Region ${boxState.pv.adr[0].adr},`
                            } else {
                                if (state.adr.length === 1) {
                                    tituloSucursal = `Region ${state.adr[0].adr},`
                                } else {
                                    tituloSucursal = `TODO EL GRUPO,`
                                }
                            }
                        } else {
                            if (boxState.pv.sucursal.length === 0) {
                                tituloSucursal += `${state.sucursal[0].idsucursal}-${state.sucursal[0].sucursal}${','}`;
                            } else {
                                boxState.pv.sucursal.forEach(item => {
                                    tituloSucursal += `${item.idsucursal}-${item.sucursal}${','}`;
                                })
                            }
                        }
                    }

                }

                //Header departamentosb

                if (boxState.pv.departamento != undefined && boxState.pv.departamento != null) {
                    if (boxState.pv.departamento.length == 0 && state.departamento.length < 11) {
                        state.departamento.forEach(item => {
                            tituloDeptos += `${item.iddepartamento}-${item.departamento}${','}`;
                        })
                    } else
                        if (boxState.pv.departamento.length == 0 && state.departamento.length !== 1) {
                            tituloDeptos = 'TODOS LOS DEPARTAMENTOS,'
                        } else {

                            if (boxState.pv.departamento.length === 0) {
                                tituloDeptos += `${state.departamento[0].iddepartamento}-${state.departamento[0].departamento}${','}`;
                            } else {
                                boxState.pv.departamento.forEach(item => {
                                    tituloDeptos += `${item.iddepartamento}-${item.departamento}${','}`;
                                })
                            }
                        }
                }


                if (updateBoxState !== undefined && updateBoxState !== null) {
                    updateBoxState({
                        ...boxState,
                        titulosucursal: tituloSucursal.substr(0, tituloSucursal.length - 1),
                        titulodepartamento: tituloDeptos.substr(0, tituloDeptos.length - 1)
                    })
                }
                setstate({
                    ...state,
                    tsucursal: tituloSucursal.substr(0, tituloSucursal.length - 1),
                    tdeptos: tituloDeptos.substr(0, tituloDeptos.length - 1)
                });

                if (loadingRef.current != undefined && loadingRef.current != null)
                    loadingRef.current.style.display = "none";
                onClose();
            })
            .catch((err) => {
                if (
                    loadingErrorRef.current != undefined &&
                    loadingErrorRef.current != null
                ) {
                    loadingCargandoRef.current.style.display = "none";
                    loadingErrorRef.current.style.display = "flex";
                    setError(JSON.stringify(err));
                }
            });
    };

    return (
        <>
            <div className='encabezado-reports-filtros-2'>
                <div>
                    <div className='filtro-titulo'>
                        <button className="boton-box-structure" onClick={onClick}>
                            Filtro
                        </button>
                        <header>
                            <div className="titulo">{titulo}</div>
                            <div className="sub-titulo">{subtitulo}</div>
                        </header>
                    </div>
                </div>
                {
                    GetChildren('box-actions')
                }
            </div>
            <div id="box-structure-bussiness-filtros-2" key="box-structure-bussiness-filtros-2">
                <div className="filtro-soy-el-titulo">
                    <div className="filtro-soy-el-titulo-header">
                        {titulo_filtro}
                        <span className="filtro-soy-span-close" onClick={onClose}>
                            X
                        </span>
                    </div>
                    <div className="filtro-soy-el-titulo-line">
                        <div className="filtro-soy-el-titulo-line-bl"></div>
                        <div className="filtro-soy-el-titulo-line-circle"></div>
                        <div className="filtro-soy-el-titulo-line-br"></div>
                    </div>
                </div>
                <div className="box-action-container-filtros">
                    <div className="filtro-tiempo-tipo">
                        <div className="filtro-group" style={{ display: dejercicio }}>
                            <label>Ejercicio</label>
                            <EjercicioByRange
                                name="ejercicioinicio"
                                value={ejercicioinicio}
                                onChange={onChange}
                                extrayear={extrayear}
                            />
                        </div>

                        <div className="filtro-group" style={{ display: dmesinicio }}>
                            <label>De</label>
                            <Mes name="periodoinicio" value={periodoinicio} onChange={onChange} />
                        </div>
                        <div className="filtro-group" style={{ display: dmesfin }}>
                            <label>A</label>
                            <Mes name="periodofin" value={periodofin} onChange={onChange} />
                        </div>

                        <div className="filtro-group" style={{ display: dcomparacion }}>
                            <label>Comparación</label>
                            <Comparacion name="comparacion" value={comparacion} onChange={onChange} />
                        </div>
                        <div className="filtro-group" style={{ display: dejercicio }}>
                            <label>Comparación contra</label>
                            <EjercicioByRange
                                name="ejerciciofin"
                                value={ejerciciofin}
                                onChange={onChange}
                                extrayear={extrayear}
                            />
                        </div>
                        {
                            GetChildren('box-filtro')
                        }

                        <div className="box-filtros-container-buttons">
                            <button className="button-accept" onClick={consultar}>
                                Cargar
                            </button>
                        </div>
                    </div>
                    {cargarfiltros === false || mostraradr === false ? (
                        <div></div>
                    ) : (
                        <div className="filtro-adr">
                            <div className="title title-adr">Región</div>
                            {adrFiltrado.map((item, index) => (
                                <div key={`${item}-${index}`} className="chk-groups">
                                    <input
                                        type="checkbox"
                                        name="chk-adr"
                                        onChange={(e) => selectedClick(e, index)}
                                        checked={item.checked}
                                        value={item.idadr}
                                    />
                                    <label>{capitalizePalabras(item.adr)}</label>
                                </div>
                            ))}
                        </div>
                    )}
                    {cargarfiltros === false || mostrarsucursal === false ? (
                        <div></div>
                    ) : (
                        <div className="filtro-sucursal">
                            <div className="title">Sucursal</div>
                            {sucursalFiltrada?.map((item, index) => (
                                <div key={`${item}-${index}`} className="chk-groups">
                                    <input
                                        type="checkbox"
                                        name="chk-sucursal"
                                        className="my-checkbox"
                                        onChange={(e) => selectedClick(e, index)}
                                        checked={item.checked}
                                        value={item.idsucursal}
                                    />
                                    <label onClick={labelclick}>{capitalizePalabras(item.sucursal)}</label>
                                </div>
                            ))}
                        </div>
                    )}
                    {cargarfiltros === false || mostrardepartamento === false ? (
                        <div></div>
                    ) : (
                        <div className="filtro-departamento">
                            <div className="title">Departamento</div>
                            {departamento.map((item, index) => (
                                <div key={`${item}-${index}`} className="chk-groups">
                                    <input
                                        type="checkbox"
                                        name="chk-departamento"
                                        onChange={(e) => selectedClick(e, index)}
                                        checked={item.checked}
                                        value={item.iddepartamento}
                                    />
                                    <label>{capitalizePalabras(item.departamento)}</label>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};
